// @ts-nocheck
import React, { Component } from 'react';
import { computed, makeObservable } from "../../../../stores/mobx-shim";
import { inject, observer } from "../../../../stores/mobx-compat";
import { withRouter } from '../../../../router-compat';

import jessica from '../../../../assets/images/jessica.jpg';
import Card from '../../../ui/Card';
import Button from '../../../ui/Button';
import StepperProgress from '../../../ui/StepperProgress';
import { PhoneIcon, MailIcon } from '../../../ui/icons';

class SetupProgress extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  get stepIndex() {
    const { domains } = this.props.store.auth.user;
    if (Object.keys(this.props.store.forms.formLinks || {}).length) return 2;
    if (domains && domains.length > 0) return 1;
    return 0;
  }

  render() {
    const steps = [
      { label: 'Install Snippet' },
      { label: 'Add a Form' },
      { label: 'Start Tracking' },
    ];

    return (
      <Card className="mb-5">
        <div
          className="grid items-center gap-6"
          style={{ gridTemplateColumns: this.props.store.ui.mobile ? '1fr' : '1.1fr 1.4fr' }}
        >
          <div className="flex items-center gap-4">
            <img
              src={jessica}
              alt="Jessica"
              style={{ width: 72, height: 72, borderRadius: '50%', border: '1px solid var(--mov-line)' }}
            />
            <div className="min-w-0">
              <h3 className="m-0 mov-display" style={{ fontSize: 22, lineHeight: 1.15 }}>
                Hey, I&apos;m Jessica. <em>Need a hand?</em>
              </h3>
              <p className="m-0 mt-1 text-[13px] text-mov-ink-soft" style={{ maxWidth: 360 }}>
                Let&apos;s chat — a few minutes is all it takes to make sure your forms are tracking right.
              </p>
              <div className="flex gap-2 mt-3 flex-wrap">
                <Button
                  variant="primary"
                  icon={PhoneIcon}
                  onClick={() => window.open('https://meetings.hubspot.com/jessica-m/qa-session-with-a-team-member', '_blank')}
                >
                  Book a call
                </Button>
                <Button
                  icon={MailIcon}
                  onClick={() => window.open('mailto:sales@movology.com', '_blank')}
                >
                  Email us
                </Button>
              </div>
            </div>
          </div>

          <div>
            <div className="mov-mono text-[11px] uppercase tracking-wider text-mov-ink-mute mb-3">
              {this.stepIndex === 2
                ? 'You\'re all set. Tracking is live.'
                : 'Complete these to start recovering leads'}
            </div>
            <StepperProgress steps={steps} current={this.stepIndex} />
          </div>
        </div>
      </Card>
    );
  }
}

export default withRouter(inject('store')(observer(SetupProgress)));
